// Tema central LogiStock Pro — paleta Dark + Yellow editorial
// Mantém as chaves usadas em todo o código antigo para minimizar churn.
//
// Princípio: sidebar/header dark, conteúdo claro neutro para legibilidade em
// tabelas. Accent amarelo (#FACC15) reservado para estados activos, badges
// de destaque e CTAs secundários. Primários ficam pretos para contraste.

export const C = {
  // Superfícies base (área de conteúdo)
  bg: '#fafafa',         // fundo geral (off-white neutro)
  surface: '#ffffff',    // cartões, modais, tabelas
  surfaceAlt: '#f4f4f5', // hover suave, blocos secundários
  border: '#e4e4e7',     // bordas finas
  borderStrong: '#d4d4d8',

  // Texto
  text: '#0a0a0a',       // texto principal (quase preto puro)
  textMuted: '#52525b',  // labels, hints, dates
  textFaint: '#a1a1aa',  // disclaimers, placeholders

  // Acções
  primary: '#0a0a0a',    // botões primários — preto sobre branco
  primaryText: '#ffffff',
  accent: '#FACC15',     // amarelo destaque (sidebar activo, badges, CTA)
  accentDark: '#EAB308', // amarelo hover/pressed
  accentText: '#0a0a0a', // texto sobre amarelo (preto p/ contraste)

  // Semântica
  danger: '#dc2626',
  dangerSoft: '#fee2e2',
  warning: '#d97706',
  warningSoft: '#fef3c7',
  success: '#16a34a',
  successSoft: '#dcfce7',
  info: '#0284c7',
  infoSoft: '#e0f2fe',

  // Extras usados em gráficos/badges
  purple: '#6264a7',

  // Sidebar / chrome dark
  sidebar: '#0a0a0a',          // sidebar background (quase preto)
  sidebarAlt: '#18181b',       // hover / blocos
  sidebarText: '#fafafa',
  sidebarMuted: '#a1a1aa',     // items inactivos
  sidebarBorder: 'rgba(255,255,255,0.08)',
  sidebarActiveBg: '#FACC15',  // item activo (amarelo)
  sidebarActiveText: '#0a0a0a',
}

// Tokens de raio/sombra coerentes em toda a app
export const R = {
  sm: '4px',
  md: '6px',
  lg: '10px',
  xl: '14px',
}

export const SHADOW = {
  sm: '0 1px 2px rgba(0,0,0,0.04)',
  md: '0 4px 12px rgba(0,0,0,0.06)',
  lg: '0 12px 32px rgba(0,0,0,0.10)',
  xl: '0 24px 60px rgba(0,0,0,0.18)',
}

// Tipografia base
export const FONT = "'Inter', 'Segoe UI', system-ui, -apple-system, sans-serif"
export const FONT_MONO = "'JetBrains Mono', ui-monospace, 'Cascadia Code', monospace"

// Logo paths (públicos)
export const LOGO_LIGHT = '/logo-claro.png'  // logo para fundos escuros
export const LOGO_DARK  = '/logo-dark.png'   // logo para fundos claros
